var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "login-layout",
    {
      attrs: {
        title: _vm.daigakuName + " 求人検索",
        showBackButton: true,
        showUserName: false,
      },
    },
    [
      _c(
        "div",
        { staticClass: "row justify-content-center input-password-container" },
        [
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "form",
              {
                attrs: { id: "login-form" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.onSubmit.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "form-group highlight " }, [
                  _c("label", { attrs: { for: "Username" } }, [
                    _vm._v("ユーザー名"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.username,
                        expression: "username",
                      },
                    ],
                    staticClass:
                      "form-control text-box single-line password font-lg",
                    attrs: {
                      autocomplete: "username email",
                      type: "text",
                      id: "Username",
                      name: "Username",
                    },
                    domProps: { value: _vm.username },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.username = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "Password" } }, [
                    _vm._v("パスワード"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password",
                      },
                    ],
                    staticClass:
                      "form-control text-box single-line password font-lg",
                    attrs: {
                      autocomplete: "current-password",
                      type: "password",
                      id: "Password",
                      name: "Password",
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-lg btn-primary btn-login",
                      on: { click: _vm.checkForm },
                    },
                    [
                      _vm._v(
                        "\n                        ログイン\n                    "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "error" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.validation.loginResult) +
                      "\n                "
                  ),
                ]),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6 text-center" }, [
            _c("div", { staticClass: "message" }, [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.daigakuName) +
                    "・" +
                    _vm._s(_vm.daigakuName) +
                    "短期大学部の学生専用です。"
                ),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v("大学に届いた求人票を掲載しています。")]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }